const actionTypes = {
    REQUEST_PERFORMANCE_METRICS: 'REQUEST_PERFORMANCE_METRICS',
    RECEIVE_PERFORMANCE_METRICS_SUCCESS: 'RECEIVE_PERFORMANCE_METRICS_SUCCESS',
    RECEIVE_PERFORMANCE_METRICS_FAILURE: 'RECEIVE_PERFORMANCE_METRICS_FAILURE'
};

export default actionTypes;